import React from "react";
import { useDispatch } from "react-redux";
import { X } from "lucide-react";

import { dateToLocale } from "@/services/Utils";
import { UPDATE_DASHBOARD_FILTER } from "@/redux/types/auth.types";

import classes from "./filter-show.module.scss";

const FilterShow = ({ filters, valueFilters, setFilters, setValueFilters }) => {
	const dispatch = useDispatch();

	const handleCleanFilter = (base_id, filter) => {
		let newFilters = { ...filters };
		let newValueFilters = { ...valueFilters };

		if (base_id) {
			let newLabels = newFilters[filter].label.split(",");
			let newValues = newFilters[filter].value.split(",");
			const indexElement = newValues.findIndex((nv) => Number(nv) === Number(base_id));

			newLabels.splice(indexElement, 1);
			newValues.splice(indexElement, 1);

			newFilters[filter].label = newLabels.toString();
			newFilters[filter].value = newValues.toString();

			newValueFilters[filter] = newValues.toString();
		} else {
			newFilters[filter].label = "";
			newFilters[filter].value = "";

			newValueFilters[filter] = "";
		}

		dispatch({
			type: UPDATE_DASHBOARD_FILTER,
			payload: newFilters,
		});

		setFilters(newFilters);
		setValueFilters(newValueFilters);
	};

	return (
		<div className={classes.showFilter}>
			{filters &&
				Object.keys(filters).map((filter, i) => {
					if (!filters[filter].label) return null;

					const labels = filters[filter].label.split(",");

					return (
						<React.Fragment key={i}>
							{labels.map((label, j) => {
								const specific_label = label.split("||");
								let base_id = "";

								if (specific_label.length > 1) {
									base_id = specific_label[0];
									label = specific_label[1];
								} else {
									label = specific_label[0];
								}

								return (
									<div key={j} className={classes.item}>
										<div className={classes.description}>{`${filters[filter].description} `}</div>
										<div className={classes.label}>{filters[filter].is_date ? dateToLocale(label) : label}</div>
										{filters[filter].removable && <X className={classes.remove} onClick={() => handleCleanFilter(base_id, filter)} />}
									</div>
								);
							})}
						</React.Fragment>
					);
				})}
		</div>
	);
};

export default FilterShow;
